import React from 'react'
import PropTypes from 'prop-types'
import { Col } from 'react-styled-flexboxgrid-tmp'
import {
  _MenuPanel,
  _ContainerFluid,
  _Row,
} from './styles'

const MenuPanel = (props) => (
  <_MenuPanel className={props.className}>
    <_ContainerFluid>
      <_Row>
        <Col xs={12}>
          <div>
            <_Row>
              <Col xs={12}>
                {props.children}
              </Col>
            </_Row>
          </div>
        </Col>
      </_Row>
    </_ContainerFluid>
  </_MenuPanel>
)

MenuPanel.propTypes = {
  children: PropTypes.node.isRequired, // eslint-disable-line
  className: PropTypes.string,
  lastSearchObj: PropTypes.shape({
    sort: PropTypes.string,
  }),
}

export default MenuPanel
